import React from "react";
import { blogcomp2Data } from "./data";
import "../assests/CSS/BlogComp2.css";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const BlogComp2 = () => {
  return (
    <div className="blog2-section">
      <div className="blog2-header">
        <h2 className="blog2-heading">Blogs</h2>
        <Link to="/blogs" className="arrow-link">
          <FaArrowAltCircleRight size={28} />
        </Link>
      </div>

      <div className="blog2-grid">
        {blogcomp2Data.slice(0, 6).map((blog) => (
          <div key={blog.id} className="blog2-card">
            <div className="blog2-image">
              <img src={blog.image} />
            </div>
            <p className="blog2-title">{blog.title}</p>
          </div>
        ))}
      </div>

     
      <div className="subscribe-banner">
        <p>
          <strong className="subscribe-p">Never miss a new blog from Thhiya.</strong>
        </p>
        <button className="subscribe-btn">Subscribe now</button>
      </div>

    
      <div className="blog2-grid">
        {blogcomp2Data.slice(6, 12).map((blog) => (
          <div key={blog.id} className="blog2-card">
            <div className="blog2-image">
              <img src={blog.image}  />
            </div>
            <p className="blog2-title">{blog.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogComp2;
